<template lang="pug">
div
    v-row
        v-col(cols=12 lg=6)
            v-select(
                v-model="selectedCar",
                :items="carList",
                label="CHOOSE ANOTHER EV",
                item-text="Name",
                solo,
                attach,
                return-object,
                @change="updateCar"
            )
        v-col(cols=12 lg=6)
            AddressFinder(
              :model="sortLocation",
              label="Sort by location"
              @change="changeSortLocation"
            )
</template>

<script>
import AddressFinder from "../components/AddressFinder.vue";
export default {
  components: { AddressFinder },
  props: ["carList", "sortLocation", "selectedCar", "sortedCars"],
  data() {
    return {
      car: this.selectedCar,
    };
  },
  methods: {
    updateCar(val) {
      console.log(this.carList.indexOf(val));
      this.$emit("updateSelected", this.carList.indexOf(val));
    },
    changeSortLocation() {
      this.$emit("changeSortLocation", this.sortLocation);
    },
  },
};
</script>
